import * as types from '../ActionTypes/ActivityActionTypes';
import { getWorkoutModelsArray } from './helpers';

const initialState = {
    statuses: {
        isActivityLoading: false,
        isMoreActivityLoading: false,
    },
    offsetId: 0,
    offsetDate: 0,
    activity: [],
    moreActivityToLoad: true,
};

export function ActivityReducer(state = initialState, { type, payload }) {
    switch (type) {
        // get activity
        case types.GET_PROFILE_ACTIVITY_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isActivityLoading: true,
                },
            };
        }

        case types.GET_PROFILE_ACTIVITY_SUCCESS: {
            const activities = getWorkoutModelsArray(payload.activity);

            return {
                ...state,
                activity: [...activities],
                offsetId: payload.offsetId,
                offsetDate: payload.offsetDate,
                statuses: {
                    ...state.statuses,
                    isActivityLoading: false,
                },
            };
        }

        case types.GET_PROFILE_ACTIVITY_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isActivityLoading: false,
                },
            };
        }

        // load more activity
        case types.LOAD_MORE_ACTIVITY_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isMoreActivityLoading: true,
                },
            };
        }

        case types.LOAD_MORE_ACTIVITY_SUCCESS: {
            const moreActivityToLoad = payload.length > 0;
            const activities = getWorkoutModelsArray(payload.activity);

            return {
                ...state,
                activity: [...state.activity, ...activities],
                moreActivityToLoad,
                offsetId: payload.offsetId,
                offsetDate: payload.offsetDate,
                statuses: {
                    ...state.statuses,
                    isMoreActivityLoading: false,
                },
            };
        }

        case types.LOAD_MORE_ACTIVITY_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isMoreActivityLoading: false,
                },
            };
        }

        // reset activity scroll
        case types.RESET_ACTIVITY_SCROLL: {
            return {
                ...state,
                moreActivityToLoad: true,
            };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/ActivityReducer.js